import {
  QuoteApiResponse,
  QuoteApiErrorResponse,
  GetElevateQuoteParams,
  CheckAllowanceParams,
  CheckAllowanceResult,
  ApproveCalldataParams,
  ApproveCalldataResult,
  CheckPermit2AllowanceResult,
  CheckPermit2AllowanceParams,
  Permit2CalldataResult,
  Permit2CalldataParams,
} from './types';

import { isElevateTokenAddress } from './utils';

import { config } from '../../config';

export class ElevateClient {
  private apiV1Url: string;
  private apiV0Url: string;
  constructor(swapApiUrl: string = config.elevate.swapApiUrl) {
    const elevateSwapUrl = swapApiUrl;
    const baseUrl = elevateSwapUrl.replace(/\/$/, '');
    this.apiV1Url = `${baseUrl}/api/v1`;
    this.apiV0Url = `${baseUrl}/api/v0`;
  }

  async getElevateQuote({
    tokenInAddress,
    tokenOutAddress,
    amountInWei,
    recipient,
    signer,
    slippagePercentage = 0.3,
  }: GetElevateQuoteParams): Promise<QuoteApiResponse | null> {
    const slippage = Math.round(slippagePercentage * 10000);
    const inputType =
      isElevateTokenAddress(tokenInAddress) || isElevateTokenAddress(tokenOutAddress)
        ? 'exactInputSingle'
        : 'exactInput';
    const params = new URLSearchParams({
      type: inputType,
      tokenIn: tokenInAddress,
      tokenOut: tokenOutAddress,
      amountIn: amountInWei,
      recipient: recipient,
      signer: signer,
      slippage: slippage.toString(),
    });

    const url = `${this.apiV0Url}/quote?${params.toString()}`;

    const response = await fetch(url);

    if (!response.ok) {
      const error: QuoteApiErrorResponse = await response.json();
      console.error(
        `Elevate SDK getQuote error: ${error.error} with code: ${error.code}`
      );
      return null;
    }
    const data: QuoteApiResponse = await response.json();
    return data;
  }

  public async checkAllowance(
    params: CheckAllowanceParams
  ): Promise<CheckAllowanceResult | null> {
    const url = new URL(`${this.apiV1Url}/approve`);
    url.searchParams.append('owner', params.owner);
    url.searchParams.append('token', params.token);
    url.searchParams.append('spender', params.spender);

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    return data;
  }

  public async getApproveCalldata(
    params: ApproveCalldataParams
  ): Promise<ApproveCalldataResult | null> {
    const response = await fetch(`${this.apiV1Url}/approve`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: params.token,
        spender: params.spender,
        amount: params.amount,
      }),
    });

    if (!response.ok) {
      await response.text();
      return null;
    }

    const data = await response.json();
    return data;
  }

  public async checkPermit2Allowance(
    params: CheckPermit2AllowanceParams
  ): Promise<CheckPermit2AllowanceResult | null> {
    const url = new URL(`${this.apiV1Url}/permit2`);
    url.searchParams.append('owner', params.owner);
    url.searchParams.append('tokenAddress', params.tokenAddress);
    url.searchParams.append('approvalAddress', params.approvalAddress);

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      await response.text();
      return null;
    }

    const data = await response.json();
    return data;
  }

  public async getPermit2Calldata(
    params: Permit2CalldataParams
  ): Promise<Permit2CalldataResult | null> {
    const response = await fetch(`${this.apiV1Url}/permit2`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        tokenAddress: params.tokenAddress,
        approvalAddress: params.approvalAddress,
        amount: params.amount,
        deadline: params.deadline,
      }),
    });

    if (!response.ok) {
      await response.text();
      return null;
    }

    const data = await response.json();
    return data;
  }
}
